import React, { Component } from 'react'
import permissions from "../../config/permission";
import API from "../../config/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import permission from "../../config/permission";

export class role extends Component {

  constructor(props) {
    super(props)
  
    this.state = {
       roles: [],
       permissions: [],
    }
  }


  componentDidMount() {
    this.getAllRole();
    this.state.roles = ["Admin", "Audit", "Techer", "Stundent"];
    this.state.permissions = permission;
    this.setState({});
  }
  
  updatePermission(event) {
    // event.preventde
  }

  getAllRole = async () => {
      try {
        let results = await API.getAllRole();
        console.log(results, 'get all roles');
  
        let data = results.data;
        console.log(data);

        try {
          data.forEach(role => {
            role.permission =  JSON.parse(role.permission);
          })
        } catch (error) {
          console.log(error)
        }

        this.setState({roles: data})
        // return console.log(results, 'result1');
        // return console.log(data, 'all role')
        // {data.map(per => (
        //   this.setState(permission= per.permission )
          // per.permission.map(role => (
          //   console.log(role.name)
          // ))
  
        // ))}
        // this.setState({ 
        //   categories : data, 
        //   thumbnail: data.thumbnail_url
        // });
  
      } catch (error) {
        console.log(error)
      }
    }

    getAllPermission = async () => {
      try {
        let results = await API.getAllPermission();
  
        let data = results.data;
        console.log(data, 'all permission')
        // {data.map(per => (
        //   this.setState(permission: per.permission )
        //   per.permission.map(role => (
        //     console.log(role.name)
        //   ))
  
        // ))}
        // this.setState({ 
        //   categories : data, 
        //   thumbnail: data.thumbnail_url
        // });
  
      } catch (error) {
        console.log(error)
      }
    }

    createOrUpdateRole = async (data) => {
      try {
        console.log(data)
        let results = await API.createOrUpdateRole(data);
        if (results.result) {
          toast.success("Your action is successful", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
        }
        console.log(results)
  
        // let data = results.data;
         
        // {data.map(per => (
        //   this.setState(permission= per.permission )
        //   per.permission.map(role => (
        //     console.log(role.name)
        //   ))
  
        // ))}
        // this.setState({ 
        //   categories : data, 
        //   thumbnail: data.thumbnail_url
        // });
  
      } catch (error) {
        console.log(error)
      }
    }

    createOrUpdatePermission = async (data) => {
      try {
        let results = await API.createOrUpdatePermission(data);
  
        return console.log(results)
        // {data.map(per => (
        //   this.setState(permission= per.permission )
          // per.permission.map(role => (
          //   console.log(role.name)
          // ))
  
        // ))}
        // this.setState({ 
        //   categories : data, 
        //   thumbnail: data.thumbnail_url
        // });
  
      } catch (error) {
        console.log(error)
      }
    }



  render() {

    // const roles = ['Super Admin', 'Admin', 'Editor', 'Controller', 'User', 'Viewer'];
    const roles = [{id: 1, name: 'Admin'}, {id: 2, name: 'Editor'}, {id: 3, name: 'Viewer'}];
    // const permissions = [{id: 1, name: 'Permission1', role_id: 1}, {id: 2, name: 'Permission2', role_id: 1}, {id: 3, name: 'Permission3', role_id: 1}, 
    //   {id: 4, name: 'Permission4', role_id: 2}, {id: 5, name: 'Permission5', role_id: 3}]

    return (
      <div class="col-lg-12">
        <ToastContainer />
        <div class="card">
          <div class="card-header">
            <h5 class="card-title"><strong>Role</strong></h5>
            {/* <a class="btn btn-xs btn-light" href="#">See all</a> */}
          </div>

          <table class="table table-hover table-has-action">
          

            <thead>
              <tr>
              <th>#</th>
                {permissions.map((permission, index) => (
                <th>{permission.name}</th>
                
              ))
              
              }
              </tr>
              
            </thead>
            <tbody>
            
              
              {roles.map((role, index) => {
                return <tr>
                  <td>{role.name}</td>
                  {/* {role.permission.map((permission, index) => (
                  <td><input value={permission.allow} onChange={(event) => {
                    permission.allow = event.target.checked? 1 : 0;
                    
                    this.createOrUpdateRole({
                      id: role.id,
                      permission: JSON.stringify(role.permission)
                    });

                    this.setState({})
                  }}  type='checkbox' checked={permission.allow} /></td>
                  ))
                  
                  } */}
                </tr>
              })};



              {/* {roles.map((role, index) => {
                return <tr>
                  <td>{role.name}</td>
                  {role.permission.map((permission, index) => (
                  <td><input value={permission.allow} onChange={(event) => {
                    permission.allow = event.target.checked? 1 : 0;
                    
                    this.createOrUpdateRole({
                      id: role.id,
                      permission: JSON.stringify(role.permission)
                    });

                    this.setState({})
                  }}  type='checkbox' checked={permission.allow} /></td>
                  ))
                  
                  }
                </tr>
              })}; */}

            </tbody>
          </table>

        </div>
      </div>
    )
  }
}

export default role

{/* <td><input onChange={(event) => {
                    data.title_kh = event.target.value;
                    this.setState({})
                  }}  type='checkbox'  /></td> */}